import { OfflineAudioData } from '@/audio/types'

export async function loadOfflineAudioData (audioBuffer: AudioBuffer) : Promise<OfflineAudioData> {
  const offlineAudioContext = new OfflineAudioContext({ length: audioBuffer.length, sampleRate: audioBuffer.sampleRate })
  const audioBufferSourceNode = offlineAudioContext.createBufferSource()
  audioBufferSourceNode.buffer = audioBuffer
  const analyser = offlineAudioContext.createAnalyser()
  analyser.smoothingTimeConstant = 0.6

  const freqData: Uint8Array[] = []
  audioBufferSourceNode.connect(analyser)
  analyser.connect(offlineAudioContext.destination)
  audioBufferSourceNode.start()

  const analyserPromises = []

  for (
    let i = 0;
    i < Math.ceil(audioBuffer.duration * offlineAudioContext.sampleRate / analyser.fftSize);
    i++
  ) {
    // grab a portion of the audio specified by the window size and the sample rate
    analyserPromises.push(offlineAudioContext.suspend(i * analyser.fftSize / offlineAudioContext.sampleRate).then(() => {
      // analyse the audio and store the frequency data
      const arr = new Uint8Array(analyser.frequencyBinCount)
      analyser.getByteFrequencyData(arr)
      freqData.push(arr)
      offlineAudioContext.resume()
    }))
  }
  offlineAudioContext.startRendering()
  await Promise.all(analyserPromises)

  return {
    frequencyData: freqData,
    fftSize: analyser.fftSize
  }
}